
import { Link, Navigate } from 'react-router-dom';
import { LoginButton, loginFresh, useAuthStore } from '@/features/auth';
import { Button, PageMotion } from '@/shared/ui';
import styles from './Login.module.css';

function readRevokedFlag(): boolean {
  try {
    return sessionStorage.getItem('session_revoked') === '1';
  } catch {
    return false;
  }
}

export function LoginPage() {
  const revoked = readRevokedFlag();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated && !revoked) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageMotion className={styles.page}>
      <h1 className={styles.title}>{revoked ? 'Сессия завершена' : 'Нужно войти заново'}</h1>
      <p className={styles.subtitle}>
        {revoked
          ? 'Этот вход был завершён. Войдите заново, чтобы продолжить работу: сессии на других сервисах не затронуты.'
          : 'Прежний вход больше не действует — так бывает после долгого перерыва. Данные и переписка на месте, их видно сразу после входа.'}
      </p>
      { }
      {revoked ? (
        <Button variant="primary" size="lg" onClick={loginFresh}>
          Войти заново
        </Button>
      ) : (
        <LoginButton />
      )}
      <Link to="/" className={styles.back}>
        Вернуться на главную
      </Link>
    </PageMotion>
  );
}
